let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jyFnw")).then(() => parcelRequire('b2rYE'));